/**
 * Filters out sender.email_signature from variables object for subject and email fields
 * @param {Object} variables - The variables object to filter
 * @returns {Object} - Filtered variables object with sender.email_signature removed
 */
export const filterSubjectEmailVariables = (variables) => {
  if (!variables) return variables;

  return {
    ...variables,
    sender:
      variables.sender?.filter(
        (variable) => variable !== 'sender.email_signature'
      ) || [],
  };
};
